import { createContext } from "react";

import { UnreadNotificationsCountContextValue } from "../types/notifications";

export const UnreadNotificationsCountContext = createContext<UnreadNotificationsCountContextValue>(
  {} as UnreadNotificationsCountContextValue,
);
